<script setup>

</script>

<template>
  <!-- TODO: adapt the text here. -->
  <div class="content"><h2>Why map the ties between French Universities and Israel?</h2>
    <p>
      Since early 2024, in response to the ongoing <a
        href="https://www.ohchr.org/sites/default/files/documents/hrbodies/hrcouncil/sessions-regular/session55/advance-versions/a-hrc-55-73-auv.pdf"
        target="_blank">genocide</a> in Palestine perpetrated by the state of Israel,
      students and staff of French
      universities increased pressure on their institutions to cut ties with companies and Israeli universities
      complicit in this crime against humanity.
      Students and staff have been calling for the academic boycott of Israel for many years prior, because Israeli
      academic institutions have been complicit in the commission of <a
        href="https://www.amnesty.org/en/documents/mde15/5141/2022/en/"
        target="_blank">apartheid</a>, <a href="https://www.alhaq.org/advocacy/20931.html"
                                          target="_blank">colonization</a>, and <a
        href="https://news.un.org/en/story/2022/10/1129942"
         target="_blank">occupation</a> against the Palestinian
      people for many decades.
      This website serves as an information source in support of their activities, and for anyone else interested in
      this issue.
    </p>
    <p>
      Based on a variety of sources, including the CORDIS-website with EU funded research projects, university
      websites, results from Freedom of Information requests and the work of Dr. Maya Wind, this website maps
      institutional ties that are current as of March 2025. It builds on research by Stop Academic Complicity 
      and students and staff at various French universities, and is a work in progress.
    </p>
    <h3>What does this overview show?</h3>
    <p>
      This overview focuses on the ongoing multi-year partenerships between Israeli universities and French universities. 
      There is two types of these institutional ties, ones conclued by bilateral contrats, others founded by the European 
      Union through the Horizon Europe funding programme for research and innovation (from 2021 to 2027).
    </p>
    <p>
      French universities is understood as public academic institutions. Therefore, this overview does not include 
      private academic institutions neither universities' investments - such as foundations -, which do not publish their 
      portfolios.
    </p>
    <p>
      In line with the calls of the <a href="https://bdsmovement.net/academic-boycott#guidelines" target="_blank"
                                       >international BDS movement</a>, the overview focuses on
      institutional ties and does
      not include collaborations between individual academics. We mapped all ties between French universities and
      Israeli academic institutions, since all Israeli academic institutions are documented and known to be actively
      complicit in the violation of Palestinian rights. This makes them subject to the <a
                                                                                          href="https://bdsmovement.net/academic-boycott"
                                                                                          target="_blank">PACBI/BDS call
      for academic boycott</a>.
    </p>
    <p>
      Others important types of relationship are excluded or missing from this overview: university partenerships with 
      Israeli companies, neither campanies that has long-term relations with major international military security companies 
      that provide arms and technologies to the Israeli Defence Forces and/or are involved in ongoing cooperation with the 
      Israeli arms industry.
    </p></div>
</template>
